import React from 'react';

import PropTypes from 'prop-types';
import { FiPlay, FiPlayCircle } from 'react-icons/fi';
import styled from 'styled-components';

import { useIntl } from '@techstyle/react-intl';

const OUTLINE_WIDTH = 1;

const Button = styled.button`
  margin: 0;
  width: ${props => (props.overlay ? (props.large ? 80 : 40) : 32)}px;
  height: ${props => (props.overlay ? (props.large ? 80 : 40) : 32)}px;
  margin: 10px 10px 10px 11px;
  flex: 0 0 auto;
  border-radius: 2px;
  cursor: pointer;

  &:focus {
    outline: ${OUTLINE_WIDTH}px solid ${props => props.theme.focusColor};
  }
`;

const StyledFiPlayCircle = styled(FiPlayCircle).attrs(props => ({
  size: props.overlay ? (props.large ? 80 : 40) : 32,
}))`
  color: ${props =>
    props.overlay ? props.theme.colors.white : props.theme.colors.default};
  stroke-width: 1px;
`;

const StyledFiPlay = styled(FiPlay).attrs(props => ({
  size: props.overlay ? (props.large ? 80 : 40) : 22,
}))`
  color: ${props =>
    props.overlay ? props.theme.colors.white : props.theme.colors.default};
  stroke-width: 2px;
`;

function ProductDetailPlayButton({
  hasOutline = true,
  overlay = false,
  large = false,
  handlePlayButton,
  ...rest
}) {
  const intl = useIntl();

  return (
    <Button
      overlay={overlay}
      large={large}
      onClick={handlePlayButton}
      {...rest}
      aria-label={intl.formatMessage({
        id: 'site_bambuser.play_video',
        defaultMessage: 'Play Product Detail Video',
      })}
    >
      {hasOutline ? (
        <StyledFiPlayCircle overlay={overlay} large={large} />
      ) : (
        <StyledFiPlay overlay={overlay} large={large} />
      )}
    </Button>
  );
}

ProductDetailPlayButton.propTypes = {
  handlePlayButton: PropTypes.func,
  /**
   * Whether to render the small or large button version. Only applies to the
   * overlay version.
   */
  large: PropTypes.bool,
  hasOutline: PropTypes.bool,
  /**
   * Whether the button is overlaying a product image or appearing as a standard
   * button.
   */
  overlay: PropTypes.bool,
};

export default ProductDetailPlayButton;
